const storedUser = localStorage.getItem("applicant");

export const applicant = JSON.parse(storedUser);
